var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomaticZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.292,17.792v-3.5h-3.5v-2h3.5v-3.5h2v3.5h3.5v2h-3.5v3.5H12.292z M30.704,27.279 c0.044,0.919-0.304,1.819-0.954,2.47c-0.614,0.614-1.451,0.958-2.315,0.958c-0.052,0-0.104-0.001-0.156-0.004 c-0.919-0.044-1.782-0.476-2.367-1.185l-5.092-6.171c-1.881,1.225-4.121,1.945-6.528,1.945c-3.451,0-6.7-1.522-8.956-4.054v2.588h-2 v-6h6v2H5.752c1.882,2.163,4.626,3.466,7.541,3.466c5.514,0,10-4.486,10-10h2c0,2.408-0.719,4.647-1.945,6.528l6.171,5.091 C30.228,25.498,30.66,26.36,30.704,27.279z M28.706,27.375c-0.017-0.362-0.181-0.689-0.461-0.92l-6.129-5.058 c-0.23,0.25-0.469,0.489-0.719,0.719l5.058,6.13c0.23,0.279,0.558,0.443,0.92,0.46c0.374,0.019,0.704-0.114,0.96-0.371 C28.592,28.079,28.724,27.738,28.706,27.375z M13.292,3.292c2.915,0,5.659,1.303,7.541,3.466h-2.586v2h6v-6h-2v2.588 c-2.256-2.531-5.505-4.053-8.955-4.053c-6.617,0-12,5.383-12,12h2C3.292,7.778,7.778,3.292,13.292,3.292z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticZoom);
export default __webpack_public_path__ + "static/media/automatic-zoom.9ef29bc8b1bd1ff4f87a40ecec81412b.svg";
export { ForwardRef as ReactComponent };